import { applyMiddleware, createStore, combineReducers } from 'redux';
import createPersistor, { persistWrapper, hydrate } from 'redux-easy-persist';
import { AsyncStorage } from 'react-native';
import logger from 'redux-logger';
import UserReducer from './reducers/UserReducer';
import ProjectsReducer from './reducers/ProjectsReducer';
import OTAReducer from './reducers/OTAReducer';

const persistor = createPersistor({
	storeEngine: AsyncStorage,
	persistKey: 'rootState',
});

const rootReducer = combineReducers(
	persistWrapper({
		user: UserReducer,
		projects: ProjectsReducer,
		ota: OTAReducer,
	}),
);
export type RootState = ReturnType<typeof rootReducer>;

const middlewares = [persistor];
if (__DEV__) {
	middlewares.push(logger);
}
const store = createStore(rootReducer, applyMiddleware(...middlewares));
hydrate(store);
export default store;
